module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-211.23cc82c.woff2";